<template>
  <div class="present-tab">
    <aha-dropdown-item
      class="px-4 py-4 h-full border-base-30 border-b"
      @click="$emit('handlePresentMenuClick', 'present-now')"
      v-if="!isNewPresentation"
    >
      <div class="flex justify-between items-center">
        <p class="font-bold text-secondary-100 flex gap-4 items-center">
          <aha-icon
            name="aha-presentation-chart"
            class="text-transparent"
            viewBox="0 0 16 16"
          />
          <span>{{ $i18nPresenter.t('Present from the current slide') }}</span>
        </p>
        <span class="text-gray-70 tracking-wider">Shift P</span>
      </div>
    </aha-dropdown-item>
    <aha-dropdown-item
      class="px-4 py-4 h-full border-base-30 border-b"
      @click="$emit('handlePresentMenuClick', 'present-from-beginning')"
      v-if="!isNewPresentation"
    >
      <div class="flex gap-4 items-center">
        <aha-icon
          name="aha-presentation-chart-first"
          class="text-transparent"
          viewBox="0 0 16 16"
        />
        <p class="font-bold text-secondary-100">
          {{ $i18nPresenter.t('Present from the first slide') }}
        </p>
      </div>
    </aha-dropdown-item>
    <aha-input-group
      class="flex items-center px-4 py-4 rounded-b-lg"
    >
      <aha-checkbox
        v-model="currentUser.rememberSettings.fullscreen"
        @change="toggleFullscreenSetting"
        id="full-screen-check"
      >
        {{ $i18nPresenter.t('Full screen') }}
      </aha-checkbox>
    </aha-input-group>
  </div>
</template>

<script>
import EditorHeaderPresentButton from '@/components-v2/presentation-editor/editor-header/EditorHeaderPresentButton.vue'

export default {
  extends: EditorHeaderPresentButton,
}
</script>

<style lang="scss" scoped>
.present-tab {
  min-width: 374px;
}
</style>
